import { COLORS, SHADOWS, LABELS } from '@/game/configs';
import { Pause, RotateCcw, LogOut, Play } from 'lucide-react';
interface PauseOverlayProps {
  isOpen: boolean;
  onResume: () => void;
  onNewGame: () => void;
  onReturnToLobby: () => void;
}
export function PauseOverlay({
  isOpen,
  onResume,
  onNewGame,
  onReturnToLobby,
}: PauseOverlayProps) {
  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        backgroundColor: 'rgba(45, 45, 45, 0.7)',
        backdropFilter: 'blur(4px)',
        pointerEvents: 'all',
      }}
    >
      <div
        className="relative w-full max-w-sm mx-4 rounded-3xl p-6 sm:p-8"
        style={{
          backgroundColor: COLORS.cream,
          boxShadow: SHADOWS.deep,
        }}
      >
        <div className="flex flex-col items-center text-center gap-6">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center"
            style={{
              backgroundColor: COLORS.ivory,
              boxShadow: SHADOWS.soft,
            }}
          >
            <Pause size={40} style={{ color: COLORS.brown }} />
          </div>
          <h2
            className="text-3xl font-extrabold"
            style={{ color: COLORS.dark }}
          >
            Paused
          </h2>
          <div className="flex flex-col gap-3 w-full mt-2">
            <button
              onClick={onResume}
              className="w-full py-4 rounded-2xl font-bold text-lg transition-all duration-150 active:scale-98 flex items-center justify-center gap-2"
              style={{
                backgroundColor: COLORS.yellow,
                color: COLORS.dark,
                boxShadow: '4px 4px 8px rgba(139, 115, 85, 0.25), -4px -4px 8px rgba(255, 255, 255, 0.9)',
              }}
            >
              <Play size={20} />
              Resume
            </button>
            <button
              onClick={onNewGame}
              className="w-full py-4 rounded-2xl font-bold text-lg transition-all duration-150 active:scale-98 flex items-center justify-center gap-2"
              style={{
                backgroundColor: COLORS.ivory,
                color: COLORS.dark,
                boxShadow: SHADOWS.soft,
              }}
            >
              <RotateCcw size={20} style={{ color: COLORS.brown }} />
              New Game
            </button>
            <button
              onClick={onReturnToLobby}
              className="w-full py-4 rounded-2xl font-semibold text-base transition-all duration-150 active:scale-98 flex items-center justify-center gap-2"
              style={{
                backgroundColor: COLORS.cream,
                color: COLORS.brown,
                boxShadow: SHADOWS.soft,
              }}
            >
              <LogOut size={20} />
              Return to Lobby
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}